// extracted by mini-css-extract-plugin
export default {"root":"root--remwx","settings":"settings--WSTJr","autocomplete":"autocomplete--oPwAJ"};